import React, { useEffect, useState } from 'react';
import { researchosService } from '../../services/researchosService';
import XBackfillPanel from './XBackfillPanel';
import XHandlesPanel from './XHandlesPanel';
import TranscriptBrowser from './TranscriptBrowser';
import ExtractionStudio from './ExtractionStudio';

const GOLD = 'rgb(var(--brand-gold-rgb))';

// Chatter → X (wish #6, 2026-10-11). The ANALYSIS of X posts is not a separate thing: handle-day documents
// flow through the same extraction → graph → rails as transcripts, so Overview / Narrative / Themes /
// Relationships / Signal on the YouTube page already include them. This page is the X PLUMBING only:
//   • Backfill & Runs — add a handle with a window + post cap, preview ($0.01), backfill via the official API
//   • Handles — what we hold per handle, the daily collector's since-markers
//   • Documents — the stored handle-day documents (same browser as transcripts, scoped to X)
//   • Extraction — preview / commit / bulk-run DeepSeek on X documents (same studio, scoped to X)
const TABS = [
  { id: 'backfill', label: 'Backfill & Runs' },
  { id: 'handles', label: 'Handles' },
  { id: 'documents', label: 'Documents' },
  { id: 'extract', label: 'Extraction (DeepSeek)' },
];

function TabBtn({ on, children, onClick }) {
  return (
    <button onClick={onClick} className="rounded px-3 py-1.5 text-sm transition-colors"
      style={on ? { color: GOLD, border: `1px solid ${GOLD}`, fontWeight: 500 } : { border: '1px solid transparent', color: '#6b7280' }}>
      {children}
    </button>
  );
}

export default function XPipelinePage() {
  const [scope, setScope] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('backfill');

  useEffect(() => {
    let alive = true;
    researchosService.getScope()
      .then((r) => { if (alive) setScope(r.data); })
      .catch(() => { if (alive) setScope({ is_admin: false }); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  if (loading) return <div className="text-gray-500 dark:text-gray-400">Loading…</div>;
  if (!scope?.is_admin) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">
        X ingest is administered by the platform owner. Its posts feed the shared Signal, Narrative and Relationships views under YouTube.
      </p>
    );
  }

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-end justify-between gap-2">
        <div>
          <h2 className="font-serif text-xl text-gray-900 dark:text-gray-100">X Chatter</h2>
          <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
            Curated handles — original posts and quotes only, one document per handle per day, extracted by the daily chain like a transcript.
          </p>
        </div>
        <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-green-500">● Live</span>
      </div>
      <nav className="mb-5 flex flex-wrap items-center gap-1">
        {TABS.map((t) => <TabBtn key={t.id} on={tab === t.id} onClick={() => setTab(t.id)}>{t.label}</TabBtn>)}
      </nav>
      {tab === 'backfill' && <XBackfillPanel />}
      {tab === 'handles' && <XHandlesPanel />}
      {tab === 'documents' && <TranscriptBrowser sourceType="x" />}
      {tab === 'extract' && <ExtractionStudio sourceType="x" />}
    </div>
  );
}
